<template>
    <div class="c-event-filter-wrap">
        <FilterGroup :submit-url="submitUrl"/>
    </div>
</template>

<script>
    import FilterGroup from "../components/FilterGroup";

    export default {
        name: "App",
        props: {
            submitUrl: {
                type: String,
                required: true
            },
        },
        components: {
            FilterGroup
        },
    }
</script>

<style scoped>

</style>
